module.exports = __webpack_public_path__ + "static/close.85baf338b6403ce997af949456d58a04.svg";